export default {
    type: 'badges',
    name: 'Badges',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleBadges',
            loader: () => import('./ModuleBadges')
        },
        form: {
            name: 'ModuleBadgesForm',
            loader: () => import('./ModuleBadgesForm')
        }
    }
};
